import React from "react";
import './Layout.css'
function Header() {
  return (
    <header className="jumbotron header">
      <div className="container text-white">
        <h1 className="display-4">Flashcard-o-matic</h1>
        <p className="lead">Discover The Flashcard Difference.</p>
      </div>
    </header>
  );
}

export default Header;
